<template>
  <ModalPrimary v-bind="modalAttrs"
                v-on="$listeners"
                :name="name">
    <div :style="containerStyle">
      <div :style="textContainerStyle">
        <slot>
          <div>
            {{ text }}
          </div>
        </slot>
      </div>
      <div :style="buttonsContainerStyle">
        <ButtonSecondary :style="{ ...buttonStyle, minWidth: minWidthNoButton }"
                         @click="onNo">
          {{ labelNo }}
        </ButtonSecondary>
        <ButtonPrimary :style="{ ...buttonStyle, minWidth: minWidthYesButton }"
                       @click="onYes">
          {{ labelYes }}
        </ButtonPrimary>
      </div>
    </div>
  </ModalPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/button/button-primary'
  import ButtonSecondary from '@modules/button/button-secondary'
  import ModalPrimary from '@modules/modal/modal-primary'
  import { Layout } from '@js/styles'

  export default {
    name: 'ModalConfirmation',
    components: {
      ButtonPrimary,
      ButtonSecondary,
      ModalPrimary,
    },
    props: {
      name: { type: String, required: true, },
      text: { type: String, required: false, default: '', },
      width: { type: String, required: false, default: '360px', },
      height: { type: String, required: false, default: '200px', },
      labelYes: { type: String, reuqired: false, default: 'OK', },
      labelNo: { type: String, required: false, default: 'Cancel', },
      minWidthYesButton: { type: String, required: false, default: '100px', },
      minWidthNoButton: { type: String, required: false, default: '100px', },
    },
    data: function () {
      return {
        buttonStyle: {
          margin: `0 ${Layout.space.md}`,
        },
        buttonsContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        },
        containerStyle: {
          alignItems: 'space-between',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: Layout.space.md,
          height: `${parseInt(this.height) - 48}px`,
          width: '100%',
        },
        modalAttrs: {
          maxWidth: parseInt(this.width),
          minHeight: parseInt(this.height),
        },
        textContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          textAlign: 'center',
          width: '100%',
        },
      };
    },
    methods: {
      onYes: function () {
        this.$emit('yes');
        this.$modal.hide(this.name);
      },
      onNo: function () {
        this.$emit('no');
        this.$modal.hide(this.name);
      },
    },
  };
</script>
